import React from 'react'
// import { Button } from 'antd'
import { Link } from 'react-router-dom'
import './modual.css'

const Landing = () => {
  return (
    <>
      <div className='landing-page'>
        <Link to="/swap" style={{
          fontSize:"22px",
          fontFamily:"'Kanit',sans-serif;",
          padding: "23px",
          backgroundColor: '#751113',
          color: 'white',
          borderRadius: '16px',
          position: 'absolute',
          top: "5%",
          left: "90%",
          transform: "translate(-50%,-50%)",
          // box-sizing: border-box,
          // padding: 8px 0.85rem;
        }}>
          Launch App
        </Link>
      </div>
    </>
  )
}

export default Landing
